
import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Trending01 from "../assets/trending-01.png";
import Trending02 from "../assets/trending-02.png";
import Trending03 from "../assets/trending-03.png";
import Trending04 from "../assets/trending-04.png";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TopDeals = () => {
  const { t, i18n } = useTranslation();
  // Swiper will re-render when language changes, so key is set to language
  return (
    <>
      <Swiper
        key={i18n.language}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 3000 }}
        navigation={false}
        pagination={{ clickable: true }}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          992: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
        className="trending-slider-main"
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
      >
        {/* Slide 1 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending01} alt="Deal 1" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("Up to 50% Discount on Early Booking")}</p>
            </div>
          </Link>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending02} alt="Deal 2" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("Extra $200 on Winter Tours coupon gift")}</p>
            </div>
          </Link>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending03} alt="Deal 3" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("In Hotels Near Cities A Short Break!")}</p>
            </div>
          </Link>
        </SwiperSlide>

        {/* Slide 4 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending04} alt="Deal 4" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("In Hotels Near Cities A Short Break!")}</p>
            </div>
          </Link>
        </SwiperSlide>

        {/* Slide 5 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending02} alt="Deal 5" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("Extra $200 on Winter Tours coupon gift")}</p>
            </div>
          </Link>
        </SwiperSlide>

        {/* Slide 6 */}
        <SwiperSlide className="item">
          <Link to="/hotel" className="trending-box">
            <div className="trending-img">
              <img src={Trending03} alt="Deal 6" />
            </div>
            <div className="trending-text">
              <span className="heading-text">{t("Last Day is March 13!")}</span>
              <p>{t("In Hotels Near Cities A Short Break!")}</p>
            </div>
          </Link>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default TopDeals;